import React from 'react';
import { steps } from '../data/matteklar';
export function HowItWorks() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-179" data-mp="7slouvmylvq0">
      <div className="mx-auto max-w-6xl" data-id="element-180" data-mp="3pyrocy9gisb3">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-181" data-mp="3q02qyur61u0m">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl lg:col-span-7" data-id="element-182" data-mp="3tzk0q0dmldbl">
            Slik fungerer <em className="text-red-700" data-id="element-183" data-mp="lktiieiy56kh">NATURFAG KLAR™</em>
          </h2>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-184" data-mp="qibhbc3925er">
            Fra nedlasting til klasserom: forbered neste time på bare fem minutter.
          </p>
        </div>

        <ol className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-185" data-mp="gsry25bmk9jd">
          {steps.map((step, index) => <li key={step.title} className="relative border-t-2 border-slate-900 pt-6" data-id="element-186" data-mp="14i30rscjce05" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700" aria-hidden="true" data-id="element-187" data-mp="19a4ezjt9kest">
                {index + 1}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-188" data-mp="2rjbh332biime">
                <span className="sr-only" data-id="element-189" data-mp="2mki3zbqy0tmr">Steg {index + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-slate-900/70" data-id="element-190" data-mp="31dak04a7u6fe">{step.text}</p>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-191" data-mp="3ac5qlhh69ij8">
          Åpne → velg → forbered → undervis. Enkelt og strukturert.
        </p>
      </div>
    </section>;
}